module.exports = __webpack_public_path__ + "static/allorganicrainbowteether-7c0881eddd20ae930649d7648c181165.jpeg";